import PropTypes from 'prop-types';

const CircleCheck = ({ color, size, ...props }) => (
    <svg viewBox="0 0 19 19" width={size} height={size} {...props}>
        <path
            d="M9.5 0A9.5 9.5 0 1 0 19 9.5 9.52 9.52 0 0 0 9.5 0m4.522 7.838-5.353 5.115a.74.74 0 0 1-.512.2.7.7 0 0 1-.502-.2l-2.677-2.558a.731.731 0 1 1 1.005-1.06l2.174 2.074 4.86-4.631a.73.73 0 0 1 1.005 1.06"
            fill={color}
        />
    </svg>
);

export default CircleCheck;

CircleCheck.propTypes = {
    color: PropTypes.string.isRequired,
    size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};
